import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('./views/DashboardView.vue')
  },
  {
    path: '/units',
    name: 'Units',
    component: () => import('./views/MainViews/UnitsView.vue')
  },
  {
    path: '/units/:unitId',
    component: () => import('./views/Profiles/UnitProfile.vue')
  },
  {
    path: '/tenants/:tenantId',
    component: () => import('./views/Profiles/TenantProfile.vue')
  },
  {
    path: '/owners/:ownerId',
    component: () => import('./views/Profiles/OwnerProfile.vue')
  },
  {
    path: '/tenants',
    name: 'Tenants',
    component: () => import('./views/MainViews/TenantsView.vue')
  },
  {
    path: '/projects',
    name: 'Projects',
    component: () => import('./views/MainViews/ProjectsView.vue')
  },
  {
    path: '/accesscards',
    name: 'Access Cards',
    component: () => import('./views/MainViews/AccessCardsView.vue')
  },
  {
    path: '/parkingslots',
    name: 'Parking Slots',
    component: () => import('./views/MainViews/ParkingSlotsView.vue')
  },
  {
    path: '/projects/:projectId',
    component: () => import('./views/Profiles/ProjectProfile.vue')
  },
  {
    path: '/rooms/:roomId',
    component: () => import('./views/Profiles/RoomProfile.vue')
  },
  {
    path: '/accesscards/:accessCardId',
    component: () => import('./views/Profiles/AccessCardProfile.vue')
  },
  {
    path: '/parkingslots/:parkingSlotId',
    component: () => import('./views/Profiles/ParkingSlotProfile.vue')
  },
  {
    path: '/owners',
    name: 'Owners',
    component: () => import('./views/MainViews/OwnersView.vue')
  },
  {
    path: '/rooms',
    name: 'Rooms',
    component: () => import('./views/MainViews/RoomsView.vue')
  },
  {
    path: '/addtenant',
    name: 'Add Tenant',
    component: () => import('./views/NewRecords/AddTenant.vue')
  },
  {
    path: '/addowner',
    name: 'Add Owner',
    component: () => import('./views/NewRecords/AddOwner.vue')
  },
  {
    path: '/addunit',
    name: 'Add Unit',
    component: () => import('./views/NewRecords/AddUnit.vue')
  },
  {
    path: '/addroom',
    name: 'Add Room',
    component: () => import('./views/NewRecords/AddRoom.vue')
  },
  {
    path: '/addaccesscard',
    name: 'Add Access Card',
    component: () => import('./views/NewRecords/AddAccessCard.vue')
  },
  {
    path: '/addparkingslot',
    name: 'Add Parking Slot',
    component: () => import('./views/NewRecords/AddParkingSlot.vue')
  },
  {
    path: '/addproject',
    name: 'Add Project',
    component: () => import('./views/NewRecords/AddProject.vue')
  },
  {
    path: '/addpaymentrecord/:tenantId',
    name: 'Add Payment Record',
    component: () => import('./views/NewRecords/AddPaymentRecord.vue')
  },
  {
    path: '/addmaintenancerecord/:unitId',
    name: 'AddMaintenanceRecord',
    component: () => import('./views/NewRecords/AddMaintenanceRecord.vue')
  },
  {
    path: '/settings',
    namee: 'Settings',
    component: () => import('./views/SettingsView.vue')
  },
  {
    path: '/messaging',
    namee: 'MessagingView',
    component: () => import('./views/Messaging/MessagingView.vue')
  },
  {
    path: "/confirmation",
    name: "MessageConfirmation",
    component: () => import("./views/Messaging/MessageConfirmation.vue"),
  },
  {
    path: "/datapopulation",
    name: "DataPopulation",
    component: () => import("./views/DataPopulationView.vue"),
  },
  {
    path: "/datapopulationconfirmation",
    name: "DataPopulationConfirmation",
    component: () => import("./views/DataPopulationConfirmation.vue"),
    props: true,
  },
  {
    path: '/paymentrecorddetails/:transactionId',
    name: 'PaymentRecordDetails',
    component: () => import('./views/Profiles/PaymentRecordDetails.vue')
  },
  {
    path: '/tenancies/',
    name: 'Tenancies',
    component: () => import('./views/MainViews/TenanciesView.vue')
  },
  {
    path: '/addtenancy/',
    name: 'AddTenancy',
    component: () => import('./views/NewRecords/AddTenancy.vue')
  },
  {
    path: '/tenancy/:tenancyId',
    name: 'TenancyProfile',
    component: () => import('./views/Profiles/TenancyProfile.vue')
  },
  {
    path: '/invoice/:invoiceId',
    name: 'InvoiceProfile',
    component: () => import('./views/Profiles/InvoiceProfile.vue')
  },
  {
    path: '/payments',
    name: 'Payments',
    component: () => import('./views/MainViews/PaymentsView.vue')
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;